import { useContext } from 'react';
import { getFormattedDate } from '../utils/utils';
import { TranslationsContext } from '../../context/translations';

/* eslint-disable camelcase */
export class OrderListModel {
  constructor(data) {
    const {
      createdAt,
      status,
      s1_order_for,
      s1_sw_lead_source_company,
      s2_customerinformation_legal_business_name,
      s2_customerinformation_administrator_name,
      s2_customerinformation_administrator_last_name,
      s2_channelrep_agent_name,
      order_id,
      value_chain,
      completedAt,
      orderAssignedTo
    } = data || {};
    const {
      ORDERS: { valueChain }
    } = useContext(TranslationsContext);

    this.createdAt = getFormattedDate(createdAt);
    this.order_id = order_id;
    this.value_chain = valueChain[value_chain];

    if (s1_order_for === 'optOrder') {
      this.status = '-';
      this.s1_sw_lead_source_company = '-';
      this.s2_customerinformation_legal_business_name = '-';
      this.s2_channelrep_agent_name = '-';
      this.completedAt = '-';
      this.orderAssignedTo = '-';
    } else {
      const name =
        s2_customerinformation_legal_business_name ||
        `${s2_customerinformation_administrator_name} ${s2_customerinformation_administrator_last_name}`;
      this.status = status || '-';
      this.s1_sw_lead_source_company = s1_sw_lead_source_company || '-';
      this.s2_customerinformation_legal_business_name = name || '-';
      this.s2_channelrep_agent_name = s2_channelrep_agent_name || '-';
      this.completedAt = getFormattedDate(completedAt) || '-';
      this.orderAssignedTo =
        (orderAssignedTo &&
          `${orderAssignedTo.first_name} ${orderAssignedTo.last_name}`) ||
        '-';
    }
  }
}

export class TypeAheadModel {
  constructor(value) {
    return { label: value, id: value };
  }
}

export class ChannelModel {
  constructor(data) {
    const { name, description } = data || {};
    return { value: name, text: description };
  }
}

export class DealershipModel {
  constructor(data) {
    const { name, id } = data || {};
    return { label: name, id };
  }
}

export class UsersListModel {
  constructor(data) {
    const { id, first_name, last_name, email } = data || {};
    return { label: `${first_name} ${last_name} (${email})`, id };
  }
}

export const getOptions = (list, Model) => {
  return list && list.map(element => new Model(element));
};
